/*
 * @Author: Ximen
 * @Date: 2021-04-02 14:29:41
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-02 14:30:25
 */
const removeLocal = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('accountId');
  localStorage.removeItem('siteId');
  localStorage.removeItem('memberId');
  localStorage.removeItem('shopName');
};

export default removeLocal;
